import { Collapse as MUICollapse } from '@mui/material'

interface ICollapseProps {
  children: React.ReactNode
  isExpanded?: boolean
}

export default function Collapse({ children, isExpanded }: ICollapseProps) {
  return <MUICollapse in={isExpanded}>{children}</MUICollapse>
}
